import { Injectable } from '@angular/core';
import { CidadeDto, GetCidadesInput } from './models';
import type { PagedResultDto, Rest } from '@abp/ng.core';
import { RestService } from '@abp/ng.core';

@Injectable({
  providedIn: 'root',
})
export class CidadeService {
  apiName = 'Default';

  constructor(private restService: RestService) {}

  getList = (input: GetCidadesInput, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<CidadeDto>>(
      {
        method: 'GET',
        url: '/api/app/cidades',
        params: {
          filterText: input.filterText,
          sorting: input.sorting,
          skipCount: input.skipCount,
          maxResultCount: input.maxResultCount,
          nome: input.nome,
          mesorregiao: input.mesorregiao,
          estado: input.estado,
          regiao: input.regiao,
          pais: input.pais,
        },
      },
      { apiName: this.apiName, ...config }
    );

  getMessoregioes = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, string[]>(
      {
        method: 'GET',
        url: '/api/app/cidades/mesorregioes',
        params: {},
      },
      { apiName: this.apiName, ...config }
    );

  getEstados = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, string[]>(
      {
        method: 'GET',
        url: '/api/app/cidades/estados',
        params: {},
      },
      { apiName: this.apiName, ...config }
    );

  getRegioes = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, string[]>(
      {
        method: 'GET',
        url: '/api/app/cidades/regioes',
        params: {},
      },
      { apiName: this.apiName, ...config }
    );

}
